import axiosInstance from './axios';
import { generateIdempotencyKey } from '../utils/idempotency';

export const wheelService = {
  getUserWheelData: async (params?: { page?: number; limit?: number }) => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const page = params?.page ?? 1;
    const limit = params?.limit ?? 5;
    const response = await axiosInstance.get(
      `/client/site-wheel?siteId=${siteId}&page=${page}&limit=${limit}&queuePage=${page}&queueLimit=${limit}`,
    );
    return response.data;
  },
  spinUserWheel: async (idempotencyKey?: string) => {
    const key = idempotencyKey || generateIdempotencyKey();
    const response = await axiosInstance.post(
      '/client/site-wheel/spin',
      {},
      {
        headers: {
          'Idempotency-Key': key,
        },
      },
    );
    return response.data;
  },
  claimReward: async (body: any, idempotencyKey?: string) => {
    const key = idempotencyKey || generateIdempotencyKey();
    const response = await axiosInstance.post('/client/site-wheel/claim', body, {
      headers: {
        'Idempotency-Key': key,
      },
    });
    return response.data;
  },
  getRecentSpins: async (limit = 20) => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const response = await axiosInstance.get(
      `/client/site-wheel/recent?limit=${limit}&siteId=${siteId}`,
    );
    return response.data;
  },
};
